module.exports = __webpack_public_path__ + "img/id01.99bd9de7.png";